module.exports = __webpack_public_path__ + "static/media/payment-green.008606ee.svg";